module.exports = __webpack_public_path__ + "static/media/chip-prezao462x258.037bf66f.png";